import { IIconBase } from '..'

const availableForUpdateIcon = ({
  color = '#B08607',
  height = 24,
  width = 25,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/clipboard-tick'>
        <g id='clipboard-tick'>
          <g id='Group'>
            <path
              id='Vector'
              d='M8 10.6802H15.4C16.29 10.6802 17 11.4002 17 12.2802V14.0502'
              stroke={color}
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_2'
              d='M9.69 9L8 10.6801L9.69 12.3701'
              stroke={color}
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_3'
              d='M17 16.9999H9.60001C8.71001 16.9999 8 16.2799 8 15.3999V13.6299'
              stroke={color}
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_4'
              d='M15.3101 18.6801L17.0001 17.0001L15.3101 15.3101'
              stroke={color}
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <path
            id='Vector_5'
            d='M10.5 6H14.5C16.5 6 16.5 5 16.5 4C16.5 2 15.5 2 14.5 2H10.5C9.5 2 8.5 2 8.5 4C8.5 6 9.5 6 10.5 6Z'
            stroke='#333752'
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_6'
            d='M16.5 4.02002C19.83 4.20002 21.5 5.43002 21.5 10V16C21.5 20 20.5 22 15.5 22H9.5C4.5 22 3.5 20 3.5 16V10C3.5 5.44002 5.17 4.20002 8.5 4.02002'
            stroke='#333752'
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default availableForUpdateIcon
